import { ReactNode } from 'react'
import LandingGrid from '../assets/checker/landing-grid-bg.png'
import ProfileCardSlider from './landing/ProfileCardSlider'

interface AuthContainerProps {
  children: ReactNode
}

export default function AuthContainer({ children }: AuthContainerProps) {
  return (
    <section className='min-h-[calc(100vh-64px)] md:min-h-[calc(100vh-72px)] relative bg-[#ECECEC] mx-4 md:mx-6 lg:mx-10 my-4 md:my-6 lg:my-8 rounded-[16px] md:rounded-[20px] overflow-hidden flex items-center snap-start'>
      <div className='w-full flex flex-col lg:flex-row items-center justify-between px-6 md:px-10 lg:pl-16 lg:pr-12 py-8 md:py-12 lg:py-0 relative z-10 min-h-full'>
        {/* Left Content - Flexible for Auth Forms */}
        <div className='flex-shrink-0 w-full lg:max-w-[600px] h-full flex items-center justify-center lg:justify-start'>
          <div className='w-full max-w-[500px]'>
            {children}
          </div>
        </div>

        {/* Right Content - Animated Profile Card over the faded candidate grid - Desktop Only */}
        <div className='hidden lg:flex flex-1 items-center justify-end'>
          <div className='relative w-full max-w-[640px]'>
            {/* Faded candidate-grid backdrop */}
            <img
              src={LandingGrid}
              alt=''
              aria-hidden='true'
              className='pointer-events-none select-none w-full h-auto opacity-[0.45]'
            />
            {/* Active card sits over the cleared center slot */}
            <div className='absolute inset-0 flex items-center justify-center'>
              <ProfileCardSlider />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
